import script from "./PartnersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersPage.vue?vue&type=script&setup=true&lang=js"

import "./PartnersPage.vue?vue&type=style&index=0&id=450cbe4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450cbe4e"]])

export default __exports__